import React, { useEffect, useContext } from 'react';
import { ClipLoader } from 'react-spinners';
import { AuthContext } from '../providers/AuthProvider';
import config from '../../config';

const { redirectUrl } = config;
const Logout = () => {
  const authService = useContext(AuthContext);
  useEffect(() => {
    localStorage.setItem('redirectUri', redirectUrl);
    function logout() {
      authService.logout();
    }
    logout();
  }, [authService]);
  return <ClipLoader label="Logging you out" />;
};
export default Logout;
